import React, { useContext } from "react";

import { Heading } from "@magnetic/heading";

import { CiscoLogo } from "src/common/ciscoLogo";
import { Button } from "src/components/buttons";
import { HFlex } from "src/components/hFlex";
import { VFlex } from "src/components/vFlex";
import { Constants } from "src/utils/constants";

import { LoginContext } from "./loginContext";

import "./welcomeScreen.scss";

export const ContactSales = () => {
  const { logout } = useContext(LoginContext);

  return (
    <VFlex className="welcome" gap="sm">
      <VFlex className="welcome" align="center" gap="lg">
        <CiscoLogo />
        <Heading size="h1">Not yet a {Constants.APP_NAME} member</Heading>
        <p>
          You are authenticated correctly but you are not an active member of{" "}
          {Constants.APP_NAME}.
        </p>
      </VFlex>
      <HFlex align="stretch" justify="flex-start">
        <Button name="logout" kind="tertiary" onClick={logout}>
          &larr; Back to login
        </Button>
      </HFlex>
    </VFlex>
  );
};
